
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import WaterSupplySidebarMasterLocationWiseAreaMasterPopup from './WaterSupplySidebarMasterLocationWiseAreaMasterPopup'
import { useSearchParams } from 'react-router-dom'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { SidebarDistributionLineAreaMasterDeleteAPI, SidebarDistributionLineAreaMasterTableDataAPI } from '../../../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/WaterSupplyDistributionLineAreaMasterSlice'
import { Loading } from '../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'

export default function WaterSupplySidebarLocationWiseAreMasterDataPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [isSearch, setIsSearch] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WaterSupplySidebarMasterLocationWiseAreaPopupShow, setWaterSupplySidebarMasterLocationWiseAreaPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [FromTop, setFromTop] = useState(1)
    const [ToTop, setToTop] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)

    // const handleAddOnClick = () => {
    //     console.log("add")
    //     setRoasMasterWardPopupShow(true)
    // }

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWaterSupplySidebarMasterLocationWiseAreaPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWaterSupplySidebarMasterLocationWiseAreaPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterSupplySidebarMasterLocationWiseAreaPopupShow(false)
    }

    useEffect(() => {
        setCurrentPage(0)
        setFromTop(1)
        setToTop(10)
    }, [])

    const handleClear = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsClear(!IsClear)
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })

    }

    const handleSearch = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsSearch(!isSearch)
    }

    useEffect(() => {
        const data = {
            M_TTP_LocationID: JunctionNameDDL.ID,
            M_Distri_WS_LocationID: JunctionNameDDL.ID,
            From: FromTop,
            To: ToTop,
            M_UsersID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId
        }
        dispatch(SidebarDistributionLineAreaMasterTableDataAPI({ data }))

    }, [ToTop, IsPost, isSearch, IsClear,JunctionNameDDL.ID, DashProjectTypeId])

    const { tableData, isLoading } = useSelector(state => state.SidebarDistributionLineAreaMasterTableData)

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_TTP_AreaDetailsID: item.m_ttP_AreaDetailsID,
            M_Distri_WS_AreaDetailsID: item.m_Distri_WS_AreaDetailsID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            DashProjectTypeId: DashProjectTypeId
        }
        dispatch(SidebarDistributionLineAreaMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.SidebarDistributionLineAreaMasterDeleteData)


    return (
        <div>
            {isLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar
                    ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId}
                    active='watersupplysidebarlocationwisearemasterdatapage' 
                    listActive='watermaster' 
                    />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-12 col-lg-9'>
                                <h5 className="mt-2">Location Wise Area Master</h5>
                            </div>
                            <div className='col-7 col-lg-3 mar_add'>
                                <div className="float-end butt">
                                    <button type="button" className="btn btn-primary ml-1 float-end">Export</button>
                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            {
                                                (DashProjectTypeId == '6' || DashProjectTypeId == '9') ?
                                                    <>
                                                        <div className="col-lg-3 col-md-6">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName=''
                                                                DashProjectTypeId={DashProjectTypeId}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    ''
                                            }


                                            <div className="col-12 col-md-6 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>

                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Location</th>
                                                        <th>Area</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                <td>{item.areaDetails ? item.areaDetails : '-'}</td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {/* <span >
                                                                            <LocationMasterPopUp
                                                                                open={LocationMasterPopupShow}
                                                                                handleIsPost={handleIsPost}
                                                                                item={item}
                                                                                Flag='Update'
                                                                            />
                                                                        </span> */}
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                            item={item}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFromTop}
                                                setTo={setToTop}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    WaterSupplySidebarMasterLocationWiseAreaPopupShow ?
                        <WaterSupplySidebarMasterLocationWiseAreaMasterPopup
                            open={WaterSupplySidebarMasterLocationWiseAreaPopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}